import { makeEntityId } from '@website-builder/util/make-widget-id.utility';
import { EntityIdPrefix } from '@website-builder/model/domain/entity-id-prefix.enum';

export class DescriptionListElement {
  id = makeEntityId(EntityIdPrefix.WIDGET_ELEMENT);
  title = 'Title';
  subtitle = 'Subtitle';
  content =
    'Lorem ipsum dolor sit amet, ius prima partem postulant te, sed an omittam oportere. Eos detraxit tractatos forensibus id, eu nostrum maluisset eam.';

  static normalizeInPlace(element: DescriptionListElement): DescriptionListElement {
    const pureElement = new DescriptionListElement();

    element.title = element.title ?? pureElement.title;
    element.subtitle = element.subtitle ?? pureElement.subtitle;
    element.content = element.content ?? pureElement.content;

    return element;
  }
}
